<div class="container">
  <section class="subheader">
    <h2 *ngIf="title" [innerHTML]="title"></h2>
  </section>
</div>
